(function () {
  const routes = {
    'purse': '/collections/womens-handbags-1',
    'purses': '/collections/womens-handbags-1',
    'carry on': '/collections/luggage-travel-1',
    'carry-on': '/collections/luggage-travel-1',
    'carry on luggage': '/collections/luggage-travel-1',
    'duffel': '/collections/gym-bag',
    'duffel bag': '/collections/gym-bag',
    'weekender': '/collections/gym-bag',
    'crossbody': '/search?q=crossbody+bag&type=product',
    'cross body': '/search?q=crossbody+bag&type=product',
    'packing cubes': '/collections/storage-bag',
    'packing cube': '/collections/storage-bag',
    'organizers': '/collections/storage-bag'
  };

  function normalize(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    const target = routes[normalize(input.value)];
    if (!target) return;
    event.preventDefault();
    window.location.assign(target);
  }, true);
})();
